import { Decision } from './Decision';

export type State = 'hover' | 'active' | 'focus' | 'error' | 'disabled';

export type ComponentDecisions<V extends string = ''> = {
    [decision in Decision]?: DecisionInterface<V>;
};

interface DecisionValueInterface {
    value: string;
}

interface DecisionsStateInterface extends DecisionValueInterface {
    state?: DecisionState;
}

interface DecisionInterface<V extends string> extends DecisionsStateInterface {
    variant?: DecisionVariant<V>;
}

type DecisionState = {
    [state in State]?: DecisionValueInterface;
};

type DecisionVariant<V extends string> = {
    [variant in V]?: DecisionsStateInterface;
};
